import React, { useState, useEffect } from 'react';
import '../styles.css';

function Loading({ message = "Loading your music data..." }) {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className="loading-container">
      <div className="spotify-loader">
        <div className="spotify-loader__bar"></div>
        <div className="spotify-loader__bar"></div>
        <div className="spotify-loader__bar"></div>
      </div>
      <p className="loading-text">{message}</p>
    </div>
  );
}

export default Loading; 